import { Asset, Button, InfoFilledIcon } from '@clearcover/atlas';
import { AxiosError } from 'axios';
import React, { FC } from 'react';
import styles from './styles.module.css';

export const CardError: FC<{
  error: AxiosError | undefined;
  refetch: () => void;
}> = ({ refetch, error }) => {
  if (!error) return null;
  return (
    <div className={styles.error}>
      <Asset
        height={60}
        width={60}
        icon={InfoFilledIcon}
        className={styles.infoIcon}
        description={'Card Error Icon'}
      />
      <h2 className={styles.head}>We're Sorry</h2>
      <p className={styles.message}>
        Our services are currently down. We've already been notified and are
        working on resolving it. Please retry or come back at a later time.
      </p>
      <Button
        className={styles.button}
        variant={'secondary'}
        size={'sm'}
        onClick={() => refetch()}
      >
        Try Again
      </Button>
    </div>
  );
};
